import { render, staticRenderFns } from "./VeiculosLista.vue?vue&type=template&id=79795f64&scoped=true&"
import script from "./VeiculosLista.vue?vue&type=script&lang=js&"
export * from "./VeiculosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79795f64",
  null
  
)

export default component.exports